(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/store/game-guide-slice.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/store/game-guide-slice.js');
"use strict";

var _svs$arena;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const logger = svs.arena.logger;
const getCmsDataFolderAsync = svs.arena.service.gameGuideService.getCmsDataFolderAsync;
const gameGuideArticleFolder = ((_svs$arena = svs.arena) === null || _svs$arena === void 0 || (_svs$arena = _svs$arena.data) === null || _svs$arena === void 0 || (_svs$arena = _svs$arena.config) === null || _svs$arena === void 0 ? void 0 : _svs$arena.gameGuideArticleFolder) || '';
const fetchGameGuideArticles = RTK.createAsyncThunk('arena/fetchgameguidearticles', async (_, _ref) => {
  let rejectWithValue = _ref.rejectWithValue;
  try {
    var _response$data, _response$data2;
    svs.arena.logger.debug('fetchGameGuideArticles, start');
    const response = await getCmsDataFolderAsync(gameGuideArticleFolder);
    svs.arena.logger.debug('fetchGameGuideArticles, response: ', response);
    if (!response || response !== null && response !== void 0 && response.error) {
      return rejectWithValue({
        error: response.error.code
      });
    }
    return {
      status: 'success',
      error: null,
      dataOrg: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.result.slice(),
      data: response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.result
    };
  } catch (error) {
    svs.arena.logger.debug('fetchGameGuideArticles, error: ', error);
    return rejectWithValue({
      error
    });
  }
});

const getInitialState = () => ({
  articles: []
});
const gameGuideSlice = RTK.createSlice({
  name: 'gameguide',
  initialState: getInitialState(),
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchGameGuideArticles.fulfilled, (state, action) => {
      logger.debug('fetchGameGuideArticles.fulfilled, action: ', action);
      state.articles = action.payload.data;
    }).addCase(fetchGameGuideArticles.rejected, state => {
      logger.debug('fetchGameGuideArticles.rejected, state: ', state);
    });
  }
});
svs.arena.store.gameguide = svs.arena.store.gameguide || {};
svs.arena.store.gameguide.actions = _objectSpread({
  fetchGameGuideArticles
}, gameGuideSlice.actions);
svs.arena.store.gameguide.reducer = gameGuideSlice.reducer;
svs.arena.store.gameguide.initialState = getInitialState();

 })(window);